import React, { FC, useEffect, useState } from 'react';
import { StudyRequestInterface } from '../../interfaces';
import { useStudyRequestService } from '../../services';
import { StudyRequestForm } from '../StudyRequestForm';

interface InnerEditDialogFormInterface {
	handleSubmit: (props: any) => void;
	id: string;
}

const InnerEditDialogForm: FC<InnerEditDialogFormInterface> = ({ id, handleSubmit }) => {
	const { getStudyRequestById } = useStudyRequestService();
	const [data, setData] = useState<StudyRequestInterface | null>(null);

	useEffect(() => {
		(async () => {
			setData(await getStudyRequestById(id));
		})();
	}, [id]);

	return (
		<>
			{data && <StudyRequestForm onSubmit={handleSubmit} values={data} withNotes />}
		</>
	);
};

export default InnerEditDialogForm;
